<template>
  <a-checkbox :style="style" :checked="checked" @change="handleChange">
    <slot></slot>
  </a-checkbox>
</template>
<script>
import { eventTrack } from '@/api/common'

export default {
  props: {
    checked: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    cmsId: String,
    urls: Array,
    description: String,
    pageName: String,
    style: Object
  },
  emits: ['change'],
  methods: {
    async handleChange (e) {
      const isChecked = e.target.checked
      this.$emit('change', isChecked)

      try {
        const params = {
          name: 'agreement_track',
          description: this.description,
          page_name: this.pageName,
          action: isChecked ? 'check' : 'uncheck'
        }
        if (this.cmsId) {
          params.cms_id = this.cmsId
        }
        if (this.urls.length) {
          params.urls = this.urls
        }
        await eventTrack(params)
      } catch (err) {
        console.error('error：协议勾选记录失败')
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
